import React, { useRef } from 'react'
import { useState } from 'react';
import { getDataListAdmin } from '../../Services/Admin/ListAdminServices';
import ATable from './ATable';
import { useEffect } from 'react';

const SettingTable = (props) => {
    // console.log(props.CreateButtonWithLink)
    const aTable = useRef();
    const [sampleData, setSampleData] = useState([]);
    const [state, setAllState] = useState({
        page: 1,
        perpage: 5,
        search: '',
    });

    const setState = data => {
        setAllState(prevState => ({ ...prevState, ...data }));
    }
    
    const onSearchData = (event) => {setTimeout(() => { setState({search: event})})}
    const onChangePerPage = (data) => {setState({perpage: data})}
    const onChangePage = (type, data) => {
        if(type == 'prev'){ setState({page: page - data}) }
        if(type == 'next'){ setState({page: page + data}) }
    }
    
    function GetDataTable(page, perpage, search){
        props.data(page, perpage, search).then((result) => {
            setState({
                from: result.data.from,
                to: result.data.to,
                total: result.data.total,
                prev_page: result.data.prev_page,
                next_page: result.data.next_page,
            })
            setSampleData(result.data.data)
        }).catch(({ response }) => {
            if(response.status === 401){
                console.log(response)
            }
        });
    }
    
    const { page, perpage, search, from, to, total, next_page, prev_page } = state;
    

    const propsTable = {
        columns: props.columns,
        sampleData,
        FilterSearchAll : props.FilterSearchAll,
        CreateButtonWithLink : props.CreateButtonWithLink,
        filter:props.filter,    
        admin:props.admin,    
        page:page,
        perpage:perpage,
        from:from,
        to:to,
        total:total,
        prev_page:prev_page,
        next_page:next_page,
    };


    useEffect(() => {
        
        GetDataTable(page, perpage, search);
    }, [page, perpage, search, props.changeTab]);

  return (
    <div>
        <ATable ref={aTable} {...propsTable} searchData = {onSearchData} perpage = {onChangePerPage}  prev = {onChangePage} next = {onChangePage}/>
    </div>
  )
}

export default SettingTable